import { render, staticRenderFns } from "./ConfirmBankAccount.vue?vue&type=template&id=4b893ce6&scoped=true"
import script from "./ConfirmBankAccount.vue?vue&type=script&lang=js"
export * from "./ConfirmBankAccount.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBankAccount.vue?vue&type=style&index=0&id=4b893ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b893ce6",
  null
  
)

export default component.exports